module.exports = __webpack_public_path__ + "static/how_to_app-7e473c02b779d4967f4abf47df6deee9.png";